import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components'
import { Layout } from 'antd';

export const GlobalStyle = createGlobalStyle`

html {
    box-sizing: border-box;
}


*, *:before, *:after {
    box-sizing: inherit;
}

body {
    font-family: 'AvenirMedium';
    background: #fefefe;
    height: 100vh;
    margin: 0 auto;
    overscroll-behavior: none;
    width: 100%; 
  }

.divMarginContent{
  margin: 40px;

  @media screen and (max-width: 768px) {
    margin: 15px;
  }
}

`

const { Content } = Layout;

export const ContentLayout = styled(Content)`

  @media screen and (max-width: 1500px) {

  }

  @media screen and (max-width: 768px) {

  }
`

export const LayoutKora = styled(Layout)`
  background: unset;

  @media screen and (max-width: 768px) {
  
  }
`